import { z } from 'zod';

// Shared `/api/me` contract. Imported by the Hono handler (to validate the
// response shape it returns) and by the React client (to type the data fetched
// by useMe()). Keeping the schema in src/shared/ guarantees server and client
// never drift on the field set.
//
// Phase 1 only surfaces `login` (the GitHub handle the cookie was minted from)
// and a hard-coded `displayName` so the welcome screen can render `Hi, Dmitrii`
// without an extra round trip. Later phases may extend the user object with
// settings ids, but those additions must update this schema in lockstep.
export const MeResponseSchema = z.object({
  user: z.object({
    login: z.string().min(1),
    displayName: z.string().min(1),
  }),
});

export type MeResponse = z.infer<typeof MeResponseSchema>;

// Phase 1 derives a static display name from the user-spec ("Hi, Dmitrii").
// Centralised here so the server handler and any future client formatter
// reference one constant.
export const OWNER_DISPLAY_NAME = 'Dmitrii';
